<template>
  <b-collapse v-if="toggle" class="chart-box" :visible="isVisible()" :id="id" >
    <table class="chart-table">
      <slot></slot>
    </table>
  </b-collapse>
  <div v-else class="chart-box">
    <table class="chart-table">
      <slot></slot>
    </table>
    <div v-show="gradient" class="gradient" :class={hide:isVisible()}></div>
  </div>
</template>

<script>

export default {
  name: 'chart-box',
  props: {
    toggle: false,
    gradient: false,
    id: ''
  },
  methods: {
    isVisible: function () {
      return this.$parent.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.chart-box {
  position: relative;
  >.chart-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid $secondary;
    table-layout:fixed;
  }
  &.-hide {
    >.chart-table {
      border-top: none;
    }
  }
  &.collapsing {
    transition: all 300ms 0s ease;
    position: relative;
    overflow: hidden;
  }
  >.gradient {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(to bottom, rgba($white, 0), rgba($white, 1));
    &.hide {
      background: linear-gradient(to bottom, rgba($white, 0), rgba($white, 0));
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/charts/ChartBox.vue